import type {MemexItemModel} from '../../../models/memex-item-model'
import type {Table} from './types'

export const getIsTableGrouped = (table: Table<MemexItemModel>) => {
  const state = table.getState()
  return state.grouping?.length > 0
}
